import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IInvitation } from '@app/models/signup';
import {
  InvitationB2bClientDisplayPartnerInfosComponent,
  InvitationB2bClientDisplayPartnerInfosComponentData
} from '../modals/display-partner-infos/invitation-b2b-client-display-partner-infos.component';
import { openFaq } from '@app/shared/helpers/faq';

@Component({
  selector: 'app-invitation-b2b-client-header-partner-infos',
  templateUrl: './invitation-b2b-client-header-partner-infos.component.html',
  styleUrls: ['./invitation-b2b-client-header-partner-infos.component.scss']
})
export class InvitationB2bClientHeaderPartnerInfosComponent implements OnInit {
  @Input() invitation: IInvitation;

  constructor(
    protected dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  showPartnerInfos(): void {
    const dialogConfig: MatDialogConfig<InvitationB2bClientDisplayPartnerInfosComponentData> = {
      disableClose: true,
      width: '600px',
      panelClass: ['ik-overlay-classic', 'custom-dialog-invitation'],
      data: {
        invitation: this.invitation,
      },
    };

    this.dialog.open(InvitationB2bClientDisplayPartnerInfosComponent, dialogConfig);
  }

  openFAQ(faqId: number){
    openFaq(faqId);
  }
}
